// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/stylesheets/layout/footer.styl
// module id = 253
// module chunks = 0